// Shared helper to POST landing-page forms to the PHP mailer backend.
// Backend lives in /public/form-backend/submit-form.php and is served at
// /form-backend/submit-form.php in the static export.

export const FORM_ENDPOINT = "/form-backend/submit-form.php";

/**
 * Submit a lead to the PHP mailer.
 * @param {Object} values - { name, email, phone, message, smsConsent }
 * @param {string} [formLabel] - which form / page the lead came from
 * @returns {Promise<{ok: boolean, message?: string}>}
 */
export async function submitLeadForm(values = {}, formLabel = "") {
  const data = new FormData();
  data.append("Name", values.name ?? "");
  data.append("Email", values.email ?? "");
  data.append("Phone", values.phone ?? "");
  data.append("Message", values.message ?? "");
  // Reflects the visitor's actual SMS opt-in checkbox state — only "yes" when
  // they explicitly consented. Submission is never blocked on this value.
  data.append("TCR Compliance", values.smsConsent ? "yes" : "no");
  if (formLabel) {
    data.append("form_label", formLabel);
  }

  // Forward UTM / gclid params if present in the URL.
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid"].forEach(
      (key) => {
        const v = params.get(key);
        if (v) data.append(key, v);
      }
    );
  }

  try {
    const res = await fetch(FORM_ENDPOINT, { method: "POST", body: data });
    const json = await res.json().catch(() => ({}));
    if (res.ok && json.ok) {
      return { ok: true };
    }
    return { ok: false, message: json.message || "Something went wrong. Please try again." };
  } catch (err) {
    return { ok: false, message: "Network error. Please try again or use live chat." };
  }
}
